import { Box, Center, type BoxProps } from '@chakra-ui/react';
import { LoadingIndicator } from '@/components/shared/LoadingIndicator';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  minW?: string;
  label?: string;
}

/** @deprecated Compatibility name; renders a plain spinner, never placeholder rows. */
export function TableSkeleton({
  rows = 8,
  minW = '720px',
  label = 'Loading table',
}: TableSkeletonProps) {
  return (
    <Box overflowX="auto" w="full">
      <Center minH={`${Math.max(220, rows * 48 + 48)}px`} minW={minW} w="full">
        <LoadingIndicator size="md" label={label} />
      </Center>
    </Box>
  );
}

/** @deprecated Compatibility name; keeps the chart height around a plain spinner. */
export function ChartSkeleton({
  h = '280px',
  label = 'Loading chart',
}: {
  h?: BoxProps['h'];
  label?: string;
}) {
  return (
    <Center h={h} minH="180px" w="full">
      <LoadingIndicator size="md" label={label} />
    </Center>
  );
}

/** @deprecated Compatibility name; renders a plain spinner inside the existing region. */
export function CardStackSkeleton({ cards = 4 }: { cards?: number }) {
  return (
    <Center minH={`${Math.max(180, cards * 104)}px`} w="full">
      <LoadingIndicator size="md" label="Loading cards" />
    </Center>
  );
}
